// main.tsx — React root. Single entry point that boots the SPA.
//
// Everything funnels through here: createRoot, the App component
// (which owns the router + auth provider), and the console CSS.

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles/console.css';

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error(
    '[main] #root element missing from index.html - the Vite entry is misconfigured.',
  );
}

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
